import React from 'react'
import LeftBar from '../../Components/LeftBar'
import AddIncomeComp from './AddIncomeComp'
import Dashnav from '../../Components/Dashnav'

function AddIncome() {
  return (
        <div className='mainContainer'>
            <LeftBar/>
            <div className='theMainContainer'>
                <Dashnav/>
                <AddIncomeComp/>
            </div>
        </div>
  )
}

export default AddIncome